<template>

    <AppHead :title="episode.title" />

    <section class="px-4 xl:px-0 pb-6 md:mb-8 pt-6 md:pt-0">
        <div class="flex space-x-1.5 items-center text-sm font-medium text-gray-700 bg-white rounded-xl py-4 px-4">
            <Link class="hover:underline hover:text-gray-800" :href="route('studio.index')">Studio</Link>
            <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>
            <Link class="hover:underline hover:text-gray-800 line-clamp-1" :href="route('podcasts.edit', episode.podcast.uuid)">{{ episode.podcast.title }}</Link>
            <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>
            <Link class="hover:underline hover:text-gray-800 line-clamp-1" :href="route('episodes.edit', episode.uuid)">{{ episode.title }}</Link>
        </div>
    </section>

    <section class="px-4 xl:px-0 md:mb-12 mb-6">
        <div class="w-full flex bg-white rounded-t-xl md:rounded-2xl md:p-6 p-3 space-x-3 md:space-x-6">
            <div class="shrink-0 w-20 h-20 md:w-72 md:h-72 bg-cover bg-center rounded-xl bg-gray-300" :style="'background-image: url(' + episode.image + ')'">

            </div>
            <div class="flex-1 flex flex-col justify-between md:justify-start">
                <div class="flex w-full justify-between items-center space-x-3">
                    <div class="">
                        <div class="text-2xl md:text-3xl font-bold tracking-tight line-clamp-2 leading-none">
                            {{ episode.title }}
                        </div>
                    </div>
                    <div @click="open = true" class="shrink-0 flex border border-gray-400 rounded-full h-12 w-12 justify-center items-center text-gray-800 hover:border-gray-700 hover:text-gray-900 cursor-pointer transition-colors duration-100 ease-out active:border-gray-900">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path></svg>
                    </div>
                </div>
                <div class="text-gray-700 flex items-center">
                    <div class="mr-1.5 px-2 inline-flex text-xs leading-5 font-semibold rounded-full" :class="{ 'bg-green-100 text-green-800': episode.status == 'Published', 'bg-yellow-100 text-yellow-800': episode.status == 'Scheduled', 'bg-gray-600 text-white': episode.status == 'Processing'}">
                        {{ episode.status }}
                    </div>
                    <div v-if="episode.shared" class="mr-1.5 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-300">
                        Shared
                    </div>
                    <div class="leading-none text-sm font-medium">
                        {{ episode.published_at }}
                    </div>

                </div>
                <div class="w-full flex-1 items-end justify-between space-x-4 hidden md:flex">
                    <div class="flex-1 h-12 flex items-center">
                        <Link :href="route('podcasts.show', episode.podcast.uuid)" class="font-medium flex space-x-2 bg-white border border-gray-400 rounded-full px-4 h-12 pl-1 pr-3.5 items-center hover:border-gray-700 hover:text-gray-900 cursor-pointer transition-colors duration-100 ease-out active:border-gray-900">
                            <div class="w-10 h-10 shrink-0 rounded-full bg-center bg-cover bg-gray-300" :style="'background-image: url(' + episode.podcast.image + ')'"/>
                            <div class="flex flex-col">
                                <div class="text-xs text-gray-700 uppercase font-bold tracking-relaxed">
                                    Podcast
                                </div>
                                <div class="-mt-0.5 text-gray-800 max-w-xs text-sm line-clamp-1">
                                    {{ episode.podcast.title }}
                                </div>
                            </div>
                        </Link>
                    </div>
                    <div class="flex shrink-0 space-x-2 h-12">
                        <a :href="'mailto:?subject=' + episode.title + '&body=' + route('episodes.show', episode)" class="flex border border-gray-400 rounded-full h-12 w-12 justify-center items-center text-gray-800 hover:border-gray-700 hover:text-gray-900 cursor-pointer transition-colors duration-100 ease-out active:border-gray-900">
                            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                        </a>
<!--                         <Link :href="route('episodes.show', episode)" class="flex border border-gray-400 rounded-full h-12 px-3 pr-4 space-x-1.5 items-center text-gray-800 hover:border-gray-700 hover:text-gray-900 cursor-pointer transition-colors duration-100 ease-out active:border-gray-900">
                            <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"></path><path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"></path></svg>
                            <div class="font-medium">
                                Open in app
                            </div>
                        </Link> -->
                        <div class="">
<!--                             <div v-if="showTooltip" class="">
                                <div class="relative w-full flex items-center justify-center">
                                    <div class="flex space-x-1 -translate-y-1/2 mb-2 items-center text-white absolute w-screen max-w-[8rem] bg-regal-blue-900 rounded-md p-3 text-sm font-medium">
                                        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                                        <div class="">
                                            Link copied
                                        </div>
                                    </div>
                                    <div class="absolute -bottom-0.5 w-full flex items-center justify-center">
                                        <div class="w-3 h-3 bg-regal-blue-900 rotate-45 rounded-xs">

                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <div @click="sharingOpen = true" class="flex bg-regal-blue-700 text-white rounded-full h-12 px-3 pr-4 space-x-1.5 items-center hover:bg-regal-blue-800 cursor-pointer transition-colors duration-100 ease-out">
                                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
                                <div class="font-medium">
                                    Share
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full flex-1 items-end justify-between space-x-4 bg-white p-3 rounded-b-xl md:hidden">
            <div class="flex shrink-0 space-x-2 h-10">
                <a :href="'mailto:?subject=' + episode.title + '&body=' + route('episodes.show', episode)" class="flex border border-gray-400 rounded-full h-10 w-12 justify-center items-center text-gray-800 hover:border-gray-700 hover:text-gray-900 cursor-pointer transition-colors duration-100 ease-out active:border-gray-900">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                </a>
                <Link :href="route('episodes.show', episode)" class="flex border border-gray-400 rounded-full h-10 px-3 items-center text-gray-800 hover:border-gray-700 hover:text-gray-900 cursor-pointer transition-colors duration-100 ease-out active:border-gray-900">
                    <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"></path><path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"></path></svg>
                    <div class="font-medium hidden md:block">
                        Open in app
                    </div>
                </Link>
                <div class="flex-1 flex justify-end">
                    <div v-if="showTooltip" class="">
                        <div class="relative w-full flex items-center justify-center">
                            <div class="flex space-x-1 -translate-y-1/2 mb-2 items-center text-white absolute w-screen max-w-[8rem] bg-regal-blue-900 rounded-md p-3 text-sm font-medium">
                                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                                <div class="">
                                    Link copied
                                </div>
                            </div>
                            <div class="absolute -bottom-0.5 w-full flex items-center justify-center">
                                <div class="w-3 h-3 bg-regal-blue-900 rotate-45 rounded-xs">

                                </div>
                            </div>
                        </div>
                    </div>
                    <div @click="copy" class="flex bg-regal-blue-700 text-white rounded-full h-10 px-3 pr-4 space-x-1.5 items-center hover:bg-regal-blue-800 cursor-pointer transition-colors duration-100 ease-out">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path></svg>
                        <div class="font-medium">
                            Copy link
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <Modal v-model:open="sharingOpen">
        <div class="w-full">
            <ShareEpisode :episode="episode" :auth="$page.props.auth" v-model:emailSharingForm="emailSharingForm" @sendEmails="sendEmails" @removeShare="removeShare" @setSharing="setSharing"/>
        </div>
    </Modal>

    <Modal v-model:open="open">
        <div class="w-full">
            <form @submit.prevent="updateEpisode">
                <div class="space-y-8">
                    <div class="grid grid-cols-4 gap-x-6">
                        <div class="">
                            <label for="title" class="block font-medium text-gray-800 sm:mt-px sm:pt-2">
                                Episode title
                            </label>
                        </div>
                        <div class="col-span-3">
                            <input type="text" name="title" v-model="form.title" class="rounded-lg w-full" required>
                            <InlineError v-if="form.errors.title" :message="form.errors.title"/>
                        </div>
                    </div>
                    <div class="grid grid-cols-4 gap-x-6">
                        <div class="col-span-1 font-medium text-gray-800">
                            <label for="title" class="block font-medium text-gray-800 sm:mt-px sm:pt-2">
                                Episode cover
                            </label>
                            <div class="text-xs text-gray-700">
                                PNG, JPG, GIF up to 10MB
                            </div>
                        </div>
                        <div class="col-span-3 flex space-x-2">
                            <label for="cover-upload" ref="imageLabel"><Button label="Upload image" :type="buttonType" icon="UploadIcon" /></label>
                            <div v-if="episode.image !== episode.podcast.image" @click="removeImage">
                                <Button type="danger outline" label="Remove image" icon="TrashIcon" />
                            </div>
                            <input id="cover-upload" type="file" accept="image/*" ref="image" class="hidden" @input="uploadEpisodeImage" />
                            <InlineError v-if="form.errors.image" :message="form.errors.image" />
                        </div>
                    </div>
                    <div class="grid grid-cols-4 gap-x-6">
                        <div class="">
                            <label for="title" class="block font-medium text-gray-800 sm:mt-px sm:pt-2">
                                Episode description
                            </label>
                        </div>
                        <div class="col-span-3">
                            <textarea v-model="form.description" name="description" rows="8" cols="80" class="w-full rounded-lg"></textarea>
                            <InlineError v-if="form.errors.description" :message="form.errors.description"/>
                        </div>
                    </div>
                    <div class="grid grid-cols-4 gap-x-6">
                        <div class="">
                            <label for="dateTime" class="block font-medium text-gray-800 sm:mt-px sm:pt-2">
                                Publish date
                            </label>
                            <div class="text-xs text-gray-700">
                                <svg class="inline w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
                                All times are local ({{ episode.timezone }})
                            </div>
                        </div>
                        <div class="col-span-3">
                            <input type="datetime-local" v-model="form.dateTime" name="" class="w-full rounded-lg" required>
                            <InlineError v-if="form.errors.dateTime" :message="form.errors.dateTime"/>
                        </div>
                    </div>

<!--                     <div class="grid grid-cols-4 gap-x-6">
                        <div class="col-span-1 font-medium text-gray-800">
                            <div class="">
                                Share
                            </div>
                            <div v-if="form.sharing == 'link'">
                                <div class="text-xs text-gray-700">
                                    <svg class="inline w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path></svg>
                                    Anyone on the internet with this link can listen
                                </div>
                            </div>
                            <div v-if="form.sharing == 'members'">
                                <div class="text-xs text-gray-700">
                                    <svg class="inline w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path></svg>
                                    Only signed-in {{ $page.props.auth.account.name }} users can listen
                                </div>
                            </div>
                        </div>
                        <div class="col-span-3">
                            <select v-model="form.sharing" name="" class="w-full rounded-lg">
                                <option value="members">Members of {{ $page.props.auth.account.name }}</option>
                                <option value="link">Everyone with the link</option>
                            </select>
                            <InlineError v-if="form.errors.sharing" :message="form.errors.sharing"/>
                        </div>
                    </div> -->

                    <div class="w-full flex justify-center border-t border-t-gray-400 pt-8 justify-between">
                        <div @click="deleteEpisode">
                            <Button label="Delete episode" :disabled="form.processing" type="danger"/>
                        </div>
                        <button type="submit">
                            <Button label="Update episode" :disabled="form.processing"/>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </Modal>

    <section class="px-4 xl:px-0 md:mb-12 mb-6">
        <SectionHeading title="Analytics" importance="2"/>
        <div class="w-full flex flex-col bg-white rounded-xl md:rounded-2xl p-4 md:p-6">
            <div class="flex justify-between items-center w-full mb-6">
                <div class="text-xl font-medium">
                    Last 30 days
                </div>
                <div class="text-gray-600">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path></svg>
                </div>
            </div>
            <div class="w-full grid grid-flow-col gap-4">
                <StatsCard v-for="item in stats" :item="item" />
            </div>
        </div>
    </section>


    <section class="px-4 xl:px-0 pb-24">
        <SectionHeading title="Audio file" importance="2"/>
        <div class="w-full flex bg-white rounded-2xl md:p-6 p-3 space-x-6">
            <AudioPreview :file="episode.audio" :name="episode.title" :date="episode.created" :duration="episode.duration"/>
        </div>
    </section>

    <audio class="hidden" controls :src="episode.audio" ref="player" />

</template>

<script>
    import Layout from '@/Shared/Layout'
    import { ref } from 'vue'
    import { useForm } from '@inertiajs/inertia-vue3'
    import SectionHeading from '@/Shared/SectionHeading'
    import AudioPreview from '@/Shared/AudioPreview'
    import StatsCard from '@/Shared/StatsCard'
    import Modal from '@/Shared/Modal'
    import Button from '@/Shared/Button'
    import { Inertia } from '@inertiajs/inertia'
    import InlineError from '@/Shared/InlineError'
    import ShareEpisode from '@/Shared/ShareEpisode'

    export default {
        setup (props) {

            const open = ref(false)
            const showTooltip = ref(false)
            const sharingOpen = ref(false)
            const buttonType = ref('secondary')

            const form = useForm({
                _method: 'patch',
                title: props.episode.title,
                dateTime: props.episode.dateTime,
                description: props.episode.description,
                image: props.episode.image,
            })

            const emailSharingForm = useForm({
                emails: [],
                incompleteEmail: null,
            })

            return { form, open, showTooltip, sharingOpen, emailSharingForm, buttonType }
        },
        props: {
            episode: Object,
            stats: Object,
        },
        mounted() {
            this.$refs.player.onloadedmetadata = (e) => {
                this.duration = this.formatTime(this.$refs.player.duration)
            }
        },
        methods: {
            updateEpisode() {
                this.form.patch(route('episodes.update', this.episode), {
                    onSuccess: () => {
                        this.open = false
                    }
                })
            },
            deleteEpisode() {
                Inertia.delete(route('episodes.destroy', this.episode))
            },
            sendEmails() {
                this.emailSharingForm.post(route('episodes.share', { episode: this.episode.uuid }), {
                    onSuccess: (page) => { 
                        this.sharingOpen = false
                        this.emailSharingForm.reset()
                    },
                })
            },
            removeShare(email) {
                Inertia.patch(route('episodes.update', this.episode), {removeShare: email})
            },
            setSharing(bool) {
                Inertia.patch(route('episodes.update', this.episode), {sharing: bool})
            },
            uploadEpisodeImage(e) {
                if (!e.target.files.length) {
                    return
                }
                Vapor.store(e.target.files[0], {
                    progress: progress => {
                        this.buttonType = 'busy'
                    }
                }).then(response => {
                    this.form.image = {
                        uuid: response.uuid,
                        key: response.key,
                        bucket: response.bucket,
                        name: e.target.files[0].name,
                        content_type: e.target.files[0].type,
                    }
                    this.buttonType = 'secondary'
                    this.$refs.image.classList.remove('hidden')
                    this.$refs.imageLabel.classList.add('hidden')
                })
            },
            removeImage() {
                Inertia.patch(route('episodes.update', this.episode), {removeImage: true}, {
                    onSuccess: (page) => { 
                        this.open = true
                    },
                })
            }
        },
        layout: Layout,
        components: { SectionHeading, AudioPreview, StatsCard, Modal, Button, InlineError, ShareEpisode }
    }
</script>
